import { z } from 'zod';
import { PUBLISH_TYPE } from '../../constants';

export const createInternalNewsSchema = z
  .object({
    title: z
      .string()
      .trim()
      .min(1, 'タイトルを入力してください。')
      .max(100, '最大文字数を超えました。100文字以内で入力してください。'),
    body: z
      .string()
      .trim()
      .min(1, '本文を入力してください。')
      .max(5000, '最大文字数を超えました。5,000文字以内で入力してください。'),
    mainImage: z.file().optional(),
    publishMode: z.enum([PUBLISH_TYPE.IMMEDIATELY, PUBLISH_TYPE.SCHEDULED]),
    scheduledDate: z.date().optional(),
    scheduledTime: z.string().optional(),
    fileSignedIds: z.array(z.string()).default([]),
  })
  .superRefine((data, ctx) => {
    if (data.publishMode !== PUBLISH_TYPE.SCHEDULED) return;
    if (data.scheduledDate === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '投稿日が入力されていません。投稿日を入力してください。',
        path: ['scheduledDate'],
      });
    }
    if (!data.scheduledTime) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '投稿時間が入力されていません。投稿時間を入力してください。',
        path: ['scheduledTime'],
      });
    }
  });

export type CreateInternalNewsFormValues = z.infer<typeof createInternalNewsSchema>;
